import { CreditorState, } from '@debbie/common/dist/creditor/index.js';
import { notEmpty } from '@debbie/common/dist/util/index.js';
import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CheckCircle, Edit3, Slash, Star, XCircle } from './Icons/index.js';
import { PALETTE } from './SearchableDropdown.js';
import SearchableSelect from './SearchableSelect.js';
const STATE_ORDER = [
    CreditorState.Active,
    CreditorState.SignedOn,
    CreditorState.Lead,
    CreditorState.Cancelled,
    CreditorState.Ceased,
];
const STATE_ICON = {
    [CreditorState.Active]: { icon: React.createElement(CheckCircle, null), palette: PALETTE.success },
    [CreditorState.SignedOn]: { icon: React.createElement(Edit3, null), palette: PALETTE.accent },
    [CreditorState.Lead]: { icon: React.createElement(Star, null), palette: PALETTE.warning },
    [CreditorState.Cancelled]: { icon: React.createElement(XCircle, null), palette: PALETTE.danger },
    [CreditorState.Ceased]: { icon: React.createElement(Slash, null), palette: PALETTE.neutral },
};
const creditorId = (creditor) => creditor.creditorId;
const creditorName = (creditor) => creditor.name;
const creditorState = (creditor) => creditor.state;
const stateIcon = (creditor) => STATE_ICON[creditor.state];
const creditorExternalId = (creditor) => creditor.id;
const creditorSearchText = (creditor) => `${creditor.name} ${creditor.id} ${creditor.centralRegisterId ?? ''}`;
/**
 * Searchable select for creditors. Every row shows the creditor's id so
 * creditors with similar names can be told apart, and the search also matches
 * on id and company registration number. The list can be narrowed by state.
 */
const CreditorSelect = (props) => {
    const lang = useSelector((s) => s.lang);
    const creditors = useAllCreditors();
    const facet = useMemo(() => ({
        of: creditorState,
        options: STATE_ORDER.map((state) => ({
            key: state,
            label: lang.creditors.states[state],
            icon: STATE_ICON[state].icon,
        })),
        hideEmpty: true,
    }), [lang]);
    const description = (creditor) => [
        creditor.id,
        creditor.centralRegisterId,
        creditor.state !== CreditorState.Active
            ? lang.creditors.states[creditor.state]
            : null,
    ]
        .filter(notEmpty)
        .filter((part) => part !== '')
        .join(' · ');
    return (React.createElement(SearchableSelect, { ...props, placeholder: props.placeholder ?? lang.inputs.creditorSelect, items: creditors, getId: creditorId, getLabel: creditorName, getSearchText: creditorSearchText, getIcon: stateIcon, getDescription: description, getTriggerMeta: creditorExternalId, facet: facet, labels: {
            search: lang.creditors.searchCreditors,
            all: lang.creditors.allCreditors,
        }, recentsStorageKey: "debbie.creditorSelect.recentlyUsed" }));
};
export default CreditorSelect;
//# sourceMappingURL=CreditorSelect.js.map